module.exports = __webpack_public_path__ + "static/media/logoPatient.08c5972f.png";